import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { LinkTarget } from '../../../typings/common';
import { BetaMark } from '../../BetaMark/BetaMark';
import { RouteStyledLink } from '../../StyledLink/StyledLink';

import './SidebarLinksMenu.css';

export interface SidebarLinksMenuProps {
    links: SidebarLinksMenuLink[];
}

export interface SidebarLinksMenuLink {
    text: React.ReactNode | React.ReactNode[];
    href: string;
    isBeta?: boolean;
    target?: LinkTarget;
}

const block = 'sidebar-links-menu';

export class SidebarLinksMenu extends React.Component<SidebarLinksMenuProps> {
    render() {
        return <div className={block}>{this.getLinks()}</div>;
    }

    private getLinks() {
        return this.props.links.map((link, index) => {
            return (
                <RouteStyledLink
                    key={index}
                    href={link.href}
                    target={link.target}
                    cls={Bem.cls(block, 'item')}
                >
                    {link.text}
                    {link.isBeta ? <BetaMark /> : ''}
                </RouteStyledLink>
            );
        });
    }
}
